export const TRUSTPILOT_IDS: Record<number, string> = {
  51: '4aa8d8ed00006400050096eb',
  14: '496b0d840000640005040a84',
  37: '4ede02db000064000511c070',
  38: '4ede02db000064000511c070',
  48: '4f0475d20000640005121703',
  52: '57fb9f7a0000ff000595d664',
};

export const TRUSTPILOT_TEMPLATE_ID = '5419b6ffb0d04a076446a9af';

export const TRUSTPILOT_SLIM_HEADER_TEMPLATE_ID = '5419b757fa0340045cd0c938';
